import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {Observable} from "rxjs/Observable";
import {of} from "rxjs/observable/of";

@Injectable()
export class AssistedDashboardService {

  constructor(private http: HttpClient,) { }

  getAssistedTxnsDashboardGraphDataView(viewAssistedDashboard): any {
    // return this.http.post('/honcho/api/dashboard/admin/txns-dashboard-graph-data/view', viewAssistedDashboard, { observe: 'response' });
    return this.http.post('/honcho/api/dashboard/assisted/txns-dashboard-graph-data/view', viewAssistedDashboard, { observe: 'response' });
  }

  getDataObject(): Observable<any> {
    const txns = [100520, 25445, 36985];
    const timeperiod = ['2021', '2022', '2023'];
    const amount = [1004, 200447, 304478540];

    const dataObject = {
      txns,
      timeperiod,
      amount,
    };

    return of(dataObject);
  }

  getAssistedTxnsStaticsView(viewAssistedDashboard): Observable<any>{
    // const dataObject = {
    //   bill_fetch: 124200,
    //   bill_paid: 2025420,
    //   success_txns: 104543,
    //   total_visitors: 4524232
    //
    // };
    //
    // return of(dataObject);
    return this.http.post('/honcho/api/dashboard/admin/txns-statics/view', viewAssistedDashboard, { observe: 'response' });
  }

  getNumberOfVisitor(viewAssistedDashboard): Observable<any>{
    // const date_hour= ['Oct 2023', 'Nov 2023', 'Dec 2023'];
    // const no_of_visitors = [515611,8443654,8569852];
    // const dataObject = {
    //   date_hour,
    //   no_of_visitors
    // };
    //
    // return of(dataObject);
    return this.http.post('/honcho/api/dashboard/admin/visitor-graph-data/view', viewAssistedDashboard, { observe: 'response' });
  }

  getAdminTopBillers(): Observable<any>{
    const dataObject = {
      biller_one: 'DESCO',
      biller_two: 'DPDC',
      biller_three: 'DWAASA',
    };

    return of(dataObject);
  }

  getAssistedPaymentKeyperFormanceIndicatorView(viewAssistedDashboard): Observable<any>{
    // const dataObject = {
    //   txns_count:16131,
    //   total_amount: 78515,
    //   success_rate: 14
    // };
    //
    // return of(dataObject);
    return this.http.post('/honcho/api/dashboard/admin/payment-keyperformance-indicator/view', viewAssistedDashboard, { observe: 'response' });
  }

  getAssistedBillerPerformanceView(viewAssistedDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    // return this.http.post('/honcho/api/dashboard/admin/biller-performance/view', viewAssistedDashboard, { observe: 'response' });
    return this.http.post('/honcho/api/dashboard/assisted/biller-performance', viewAssistedDashboard, { observe: 'response' });
  }

  getAssistedPerformanceView(viewAssistedDashboard): any {
    //this.logger.debug("calling get api from Assisted Dashboard.....");
    return this.http.post('/honcho/api/dashboard/admin/syndicate-txns-amount/view', viewAssistedDashboard, { observe: 'response' });
  }

  getAssistedTxnsRegCitizenView(viewAssistedDashboard): Observable<any>{
    // const dataObject = {
    //   reg_citizen: 651111
    // };
    //
    // return of(dataObject);
    return this.http.post('/honcho/api/dashboard/admin/txns-reg-citizen/view', viewAssistedDashboard, { observe: 'response' });
  }

  getAssistedTxnsRegBillerView(viewAssistedDashboard): Observable<any>{
    // const registered_billers=[
    //   {
    //     biller_name: 'btcl',
    //     service_name: 'phone',
    //     succ_txns: 3,
    //     total_amt: 100,
    //     total_txns: 32
    //   },
    //   {
    //     biller_name: 'btcl',
    //     service_name: 'phone',
    //     succ_txns: 3,
    //     total_amt: 100,
    //     total_txns: 32
    //   },
    //   {
    //     biller_name: 'btcl',
    //     service_name: 'phone',
    //     succ_txns: 3,
    //     total_amt: 100,
    //     total_txns: 32
    //   },
    //   {
    //     biller_name: 'btcl',
    //     service_name: 'phone',
    //     succ_txns: 3,
    //     total_amt: 100,
    //     total_txns: 32
    //   },
    //   {
    //     biller_name: 'btcl',
    //     service_name: 'phone',
    //     succ_txns: 3,
    //     total_amt: 100,
    //     total_txns: 32
    //   },
    // ];
    // const dataObject = {
    //   registered_billers
    // };
    // return of(dataObject);
    // return this.http.post('/honcho/api/dashboard/admin/txns-reg-biller/view', viewAssistedDashboard, { observe: 'response' });
    return this.http.post('/honcho/api/dashboard/assisted/txns-reg-biller/view', viewAssistedDashboard, { observe: 'response' });

  }

  getAssistedTopRecordsView(viewAssistedDashboard): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/admin/top-records/view', viewAssistedDashboard, { observe: 'response' });
  }

  getAssistedPaymentTxnsAmountView(viewAssistedDashboard): Observable<any>{
    // TypeScript array for payment names
//     const paymentNames: string[] = [
//       "abbank",
//       "agentWallet",
//       "amex",
//       "bankasia",
//       "bkash",
//       "dbbl-master-debit",
//       "DBBL-MASTER-DEBIT",
//       "dbbl-visa-debit",
//       "DBBL-VISA-DEBIT",
//       "dmoney",
//       "Dmoney",
//       "ipay",
//       "master",
//       "MASTER",
//       "nagad",
//       "Nagad",
//       "nexus",
//       "NEXUS",
//       "null",
//       "primebank",
//       "qcash",
//       "rocket",
//       "sebl",
//       "sitpg",
//       "takaPay",
//       "tap",
//       "upay",
//       "visa",
//       "VISA",
//     ];
//
// // TypeScript array for total amounts
//     const totalAmounts: number[] = [
//       0,
//       0,
//       2279777.96,
//       133805,
//       82277923.48,
//       116.15,
//       0,
//       510.05,
//       0,
//       11735.28,
//       0,
//       0,
//       11085257.99,
//       0,
//       61179213.17,
//       32307,
//       739124,
//       0,
//       3085182.84,
//       0,
//       0,
//       962727.36,
//       0,
//       33.33,
//       0,
//       0,
//       15.21,
//       0,
//       1809861.99,
//       931.5,
//     ];
//
//     const dataObject = {
//       paymentNames,
//       totalAmounts
//     };
//     return of(dataObject);
    return this.http.post('/honcho/api/dashboard/admin/payment-txns-amount/view', viewAssistedDashboard, { observe: 'response' });
  }


  getAssistedPaymentSuccessRateView(viewAssistedDashboard): Observable<any>{
    // const paymentNames: string[] = [
    //   "abbank",
    //   "agentWallet",
    //   "amex",
    //   "bankasia",
    //   "bkash",
    //   "dbbl-master-debit",
    //   "DBBL-MASTER-DEBIT",
    //   "dbbl-visa-debit",
    //   "DBBL-VISA-DEBIT",
    //   "dmoney",
    //   "Dmoney",
    //   "ipay",
    //   "master",
    //   "MASTER",
    //   "nagad",
    //   "Nagad",
    //   "nexus",
    //   "NEXUS",
    //   "null",
    //   "primebank",
    //   "qcash",
    //   "rocket",
    //   "sebl",
    //   "sitpg",
    //   "takaPay",
    //   "tap",
    //   "upay",
    //   "visa",
    //   "VISA",
    // ];
    // const success: number[]=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
    // const fail: number[]=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
    // const dataObject = {
    //   paymentNames,
    //   success,
    //   fail
    // };
    // return of(dataObject);
    // return this.http.post('/honcho/api/dashboard/admin/payment-success-rate/view', viewAssistedDashboard, { observe: 'response' });
    return this.http.post('/honcho/api/dashboard/assisted/payment-success-rate-by-biller', viewAssistedDashboard, { observe: 'response' });
  }

  getAssistedTxnsDashboardReportView(viewAssistedDashboard): Observable<any>{
    // const dataObject = {
    //   reg_banks:1003,
    //   reg_billers: 44532,
    //   reg_services: 3243,
    //   total_amount: 5323464,
    //   total_txns: 633565432223,
    // };
    // return of(dataObject);
    return this.http.post('/honcho/api/dashboard/admin/txns-dashboard-report/view', viewAssistedDashboard, { observe: 'response' });
  }
}




// WEBPACK FOOTER //
// ./src/app/dashboards/assisted-dashboard/assisted-dashboard.service.ts